import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import PostList from "src/Components/Custom/PostList/PostList";
import EndPoints from "src/Constants/EndPoints";
import Sugar from "src/Constants/sugar";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import AppStateHandler from "src/StateHandlers/AppStateHandler";

function Home({ modalVisibility, setModalVisibility, search }: any) {
  const [postData, setPostData] = useState<any>([]);
  const { path } = useRouteMatch();
  const { user } = AppStateHandler.getState();
  const { data: profileResponse } = useApiFetch(
    [EndPoints.editProfile + "?subId=" + user.username],{}
  );
  const profileData = profileResponse?.data?.Items?.[0] ?? user.attributes;
  const {
    state_name,
    city_name,
  } = profileData;
  const { t, i18n } = useTranslation()
  return (
    <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
      <div className={`container-fluid ${i18n.dir() === 'rtl'?'pl-0':''}`}> 
        <div className="row">
          <div className="col-lg-9">
            <div className="col_selector">
              {path === "/home" ? (
                <div
                  className="home_search_section mb-4 post_feed px-3"
                  style={{ borderRadius: "9px" }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={
                        user.attributes.picture !== ""
                          ? user.attributes.picture
                          : "assets/images/profile-camera.png"
                      }
                      alt=""
                      className={`rounded-circle m${i18n.dir()==='rtl'?'l':'r'}-3 object_fit`}
                      width="50"
                      height="50"
                    />
                    <div
                      className="w-90 position-relative"
                      onClick={() => setModalVisibility(true)}
                    >
                      <input
                        type="text"
                        disabled={true}
                        className="form-control custom_input border-0 fz14 cursor-pointer"
                        style={{ borderRadius: "9px" }}
                        placeholder={
                          t("What's on your mind, ") +`${i18n.dir()==='rtl'?' ':''}` + user.attributes.name + `${i18n.dir()==='rtl'?'؟':'?'}`
                        }
                      />
                    </div>
                  </div>
                </div>
              ) : (
                  <></>
                )}
              <PostList
                endPoint={EndPoints.getHome}
                search={search}
                placeholderMessage={"Posts not found"}
                postData={postData}
                setPostData={setPostData}
                modalVisibility={modalVisibility}
                setModalVisibility={setModalVisibility}
              />
            </div>
          </div>
          <div className="col-xl-3">
            <div className="map">
              <iframe title="city map" width="120%" height="120%" style={{border:0}} loading="lazy"
                src={`https://www.google.com/maps/embed/v1/place?zoom=13&key=${Sugar.maps}=${city_name},${state_name},Algeria`}></iframe>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
